import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer } from 'components/';
import * as Queries from 'api/graphql/queries';
import { userList, OrderDirection, userList_listUsers_data, userList_listUsers_data_shipping_addresses } from '@api/graphql/types';
import GraphQLClient from '@api/graphql/GraphQLClient';
import ControlledTable from '@components/ControlledTable';
import UserListFilters from '../components/UserListFilters';
import { RowInfo } from 'react-table';
import { Column } from 'react-virtualized';
import { Paths } from '..';
import { DispatchProp, connect } from 'react-redux';
import { updateListOptions } from '@actions/listActions';
import { ListOptionType } from '@reducers/listReducer';
import { ApplicationState } from 'reducers/';
import { OpenInNewCell } from '@components/Table/Cell';

interface StateType {
    data: any[];
    paginatorInfo: any;
}

export interface UserFilterType {
    id: string;
    ext_id: string;
    name: string;
    email: string;
}

const UserListDefaultOptions = {
    sortBy: {
        field: 'ext_id',
        direction: OrderDirection.DESC,
    },
    count: 10,
    page: 0,
    filters: {
        id: '',
        ext_id: '',
        name: '',
        email: '',
    },
};

const listName = 'userList';

interface ReduxProps {
    listOptions: ListOptionType;
}

type Props = ReduxProps & DispatchProp & InjectedIntlProps & RouteComponentProps;

class UserList extends React.Component<Props, StateType> {

    public state = {
        data: [],
        paginatorInfo: {},
    };

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.user}/${rowInfo.original.id}`;
    });

    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName('ext_id', {sortable: true, width: 110}),
        this.getDefaultColumnByName('name', {sortable: true}),
        this.getDefaultColumnByName('email', {sortable: true}),
        this.getDefaultColumnByName('address'),
        this.getDefaultColumnByName('telephone', {width: 120}),
        this.getDefaultColumnByName('orders.paginatorInfo.total', {width: 130}),

    ];

    public componentDidMount() {
        this.fetchData();
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.listOptions !== this.props.listOptions) {
            this.fetchData();
        }
    }

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: false,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.user.${id}` });
    }

    private getFilters() {
        const result = {...this.props.listOptions.filters};
        Object.keys(result).forEach((key) => !result[key] && delete result[key]);
        return result;
    }

    private getSortBy() {
        return {
            field: this.props.listOptions.sortBy.field.toUpperCase(),
            direction: this.props.listOptions.sortBy.direction.toUpperCase(),
        };
    }

    private fetchData() {
        const variables = {...this.props.listOptions, page: this.props.listOptions.page + 1, sortBy: this.getSortBy(), filters: this.getFilters()};
        GraphQLClient.query<userList>({
            query: Queries.userList,
            variables,
        }).then(response => {
            const data = response.data.listUsers ? response.data.listUsers.data.map((item: userList_listUsers_data) => {
                const address = this.getAddress(item);
                return {...item, address};
            }) : [];
            const paginatorInfo = response.data.listUsers ? response.data.listUsers.paginatorInfo : {};
            this.setState({data, paginatorInfo});
        });
    }

    private getAddress(user: userList_listUsers_data) {
        const address = user.shipping_addresses ?
            (user.shipping_addresses.length === 1 ? user.shipping_addresses[0] : user.shipping_addresses.find((a: userList_listUsers_data_shipping_addresses) => a.is_default)) :
            null;
        if (!address) {
            return '';
        }
        return `${address.postcode} ${address.city}, ${address.street} ${address.house_number}`;
    }

    private onOptionsChange = (options: ListOptionType) => {
        this.props.dispatch(updateListOptions(listName, options));
    }

    private setFilters(values: UserFilterType) {
        const { ext_id, name, email } = values;
        const options = {
            ...this.props.listOptions,
            filters: {
                ext_id,
                name,
                email,
            },
            page: 0,
        };
        this.onOptionsChange(options);
    }

    private onRowClick = (finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any): object | undefined => {
        if (rowInfo) {
            return {
                onClick: () => {
                    this.props.history.push(`${Paths.user}/${rowInfo.original.id}`);
                },
                style: {
                    cursor: 'pointer',
                },
            };
        }
        return {};
    }


    public render() {
        return (
            <Drawer>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <UserListFilters value={this.props.listOptions.filters} onSubmit={(values: UserFilterType) => { this.setFilters(values); }} />
                                <ControlledTable
                                    listName={listName}
                                    defaultOptions={UserListDefaultOptions}
                                    columns={this.tableColumns}
                                    options={this.props.listOptions}
                                    data={this.state.data}
                                    paginatorInfo={this.state.paginatorInfo}
                                    onOptionsChange={this.onOptionsChange}
                                    onRowClick={this.onRowClick}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = ({ lists }: ApplicationState): ReduxProps => {
    return { listOptions: (lists ? (lists[listName] || UserListDefaultOptions) : UserListDefaultOptions) };
};

export default compose(
    withRouter,
    injectIntl,
    connect(mapStateToProps),
)(UserList);



// WEBPACK FOOTER //
// ./src/modules/User/pages/UserList.tsx